/**
 * 质控管理
 */

export default {
  show_reply_details_to_the_questionnaire: ['79689'], // 202503241630566037867, 在理赔登记与奖惩登记界面增加异常管理上报界面和回复界面的详情和回复内容与字段
  claims_application_dingdingApproval_unSelected: ['69650'], // 202507211606344007036, 理赔申请取消默认发起钉钉审批
  // 202511221057011272421 理赔申请界面“索赔说明”内容行长度增加至200个字符串
  claims_application_claimDescription_200Length: ['79689', '82635', '96256'],
  // 理赔类别这里，去掉 短少、污染/潮湿，只保留 破损
  claim_apply_type_customer: ['90567','90100'], // 202511101631382835901 ,202512180923510336187
}
